import { inject, Injectable } from '@angular/core';
import { INotification } from './notification-factory.service';
import { PushNotificationService } from './push-notification.service';
import { MessageTemplate } from '../../models/enums/enums';

@Injectable({
  providedIn: 'root'
})
export class MentorReviewNotificationService implements INotification {

  constructor(
    private pushNotificationService: PushNotificationService
  ) {}

  notify(message:string,data: { [key: string]: any }): void {
    this.pushNotificationService.pushNotification(message,MessageTemplate.MentorReview, data);
  }
}
